<template>
  <el-card class="VideoCardsItem">
    <div slot="header" class="header">
      <span>{{ data.name }}</span>
    </div>
    <div class="content">
      <div class="content-video">
        <el-image
          v-if="notPlay"
          style="width: 100%; height: 100%"
          :src="require('@/assets/images/video/noVideo.svg')"
          fit="fill"
          @click="notPlay = false"
        ></el-image>
        <VideoPlayer
          v-else
          :url="videoUrl"
          :isLive="isLive"
          :id="videoId"
          ref="videoRef"
        />
      </div>
      <template v-if="hasReplay && !notPlay">
        <div class="content-date">
          <DateTimePicker @dateChange="dateChange" />
        </div>
        <div class="content-control">
          <div>
            <el-button size="medium" @click="changePlayType">{{
              isLive ? "回放" : "直播"
            }}</el-button>
          </div>
          <div>
            <el-button size="medium" @click="changePlay">{{
              isPlay ? "暂停" : "播放"
            }}</el-button>
          </div>
          <div v-if="!isLive">
            <Rate :domId="videoId" />
          </div>
          <div>
            <el-button size="medium" @click="fullScreen">全屏</el-button>
          </div>
        </div>
      </template>
    </div>
  </el-card>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer/VideoPlayer";
import Rate from "@/components/VideoPlayer/Rate";
import DateTimePicker from "@/components/DatePicker/DateTimePicker";
export default {
  name: "VideoCardsItem",
  props: {
    videoId: {
      type: String,
      default: "videoCardsItem",
    },
    data: {
      type: Object,
      default: () => ({ url: "", urlBack: "" }),
    },
    hasReplay: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VideoPlayer,
    Rate,
    DateTimePicker,
  },
  data() {
    return {
      activeItem: {
        url: "",
        urlBack: "",
      },
      notPlay: false,
      timeFormatStr: "",
      isLive: true,
      isPlay: false,
      visibleRate: false,
      //当前播放速率
      rate: 1.0,
    };
  },
  computed: {
    videoUrl: function () {
      return this.isLive ? this.activeItem.url : this.activeItem.urlBack;
    },
  },
  methods: {
    dateChange(value) {
      if (value) {
        const starttime = this.$moment(value[0]).format("YYYYMMDDTHHmmss[Z]");
        const endtime = this.$moment(value[1]).format("YYYYMMDDTHHmmss[Z]");
        const newStr = `starttime=${starttime}&endtime=${endtime}`;
        this.timeFormatStr = newStr;
        const urlBackArr = this?.activeItem?.urlBack.split("starttime=");
        this.activeItem.urlBack = `${urlBackArr[0]}${newStr}`;
      } else {
        this.timeFormatStr = "";
        this.activeItem.urlBack = `${urlBackArr[0]}`;
      }
    },
    changePlayType() {
      this.isLive = !this.isLive;
      this.isPlay = false;
    },
    changePlay() {
      if (this.isPlay) {
        this.$refs.videoRef.player.pause();
      } else {
        this.$refs.videoRef.player.play();
      }
      this.isPlay = !this.isPlay;
    },
    fullScreen() {
      const element = document.getElementById(this.videoId);
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
  },
  watch: {
    videoUrl(val) {
      console.log("-----videoUrl---", val);
      if (!val) {
        this.notPlay = true;
      } else {
        if (this.notPlay) {
          this.notPlay = false;
        } else {
          this.isPlay = false;
          // this.$refs.videoRef.videoGetExeStatus()
        }
      }
    },
  },
  created() {
    this.activeItem = {
      ...this.data,
      url: `ws://127.0.0.1:8888/rtsp?url=rtsp://${this.data?.RTSP || ""}`,
      urlBack: `ws://127.0.0.1:8888/rtsp?url=rtsp://${(
        this.data?.RTSP || ""
      ).replace("Channels", "tracks")}?${this.timeFormatStr}`,
    };
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.VideoCardsItem {
  width: 100%;
  height: 100%;
  .content {
    height: 100%;
    &-video {
      width: 100%;
      height: calc(100% - 100px);
    }

    &-date {
      margin-top: 10px;
    }

    &-control {
      margin-top: 10px;
      width: 100%;
      @include setFlexBetween;
    }
  }
  ::v-deep .el-card__body {
    height: calc(100% - 96px);
  }
}
</style>
